import gameIds from '../data/GameIds';

/*
  - openModals is a priority queue of modals that should be shown.
  - waitingListModals is a queue of modals that can't be immediatly added to
  the open modal list. a waiting allows a buffer step for them to hold and
  be added when time is right.
*/
const intialState = {
  openModals: [],
  waitingListModals: [],
};

const modalSystemReducer = (state = intialState, action) => {
  if (action.gameId !== gameIds.METAGAME) {
    return state;
  }

  switch (action.type) {
    case 'OPEN_MODAL':
      return {
        ...state,
        openModals: [...state.openModals, action.payload].sort((a, b) => {
          if (a.priority > b.priority) {
            return -1;
          }
          return 1;
        }),
      };

    case 'CLOSE_MODAL': {
      const modalType = action.payload;
      const nextOpenModals = [...state.openModals];
      const modalToClose = nextOpenModals.find(m => m.modalType === modalType);
      if (modalToClose) {
        const pos = nextOpenModals.indexOf(modalToClose);
        nextOpenModals.splice(pos, 1);
      }
      return {
        ...state,
        openModals: nextOpenModals,
      };
    }

    case 'CLOSE_OPEN_MODAL': {
      const [, ...openModals] = [...state.openModals];
      return {
        ...state,
        openModals,
      };
    }

    case 'CLOSE_ALL_MODALS': {
      return {
        ...state,
        openModals: [],
        waitingListModals: [],
      };
    }

    case 'ADD_MODAL_TO_WAITING_LIST': {
      return {
        ...state,
        waitingListModals: [...state.waitingListModals, action.payload],
      };
    }

    case 'CLEAR_WAITING_LIST_MODALS': {
      return {
        ...state,
        waitingListModals: [],
      };
    }

    default:
      return state;
  }
};

export default modalSystemReducer;
